module.exports = __webpack_public_path__ + "static/media/placeholder-egg.f320b7bc.png";